import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import { getLocalizedPath } from '../i18nLanguages';
import UtilPermission from '../utils/UtilPermission';

// Guards a single page inside the already authenticated admin shell.
const PermissionRoute = ({ permission, platformOnly, children }) => {
  const location = useLocation();
  const currentUser = useSelector((state) => state.currentUser);

  if (
    (platformOnly && !currentUser?.isPlatformAdmin) ||
    (permission && !UtilPermission.hasPermission(permission, currentUser))
  ) {
    return (
      <Navigate
        to={getLocalizedPath(
          UtilPermission.getHomePath(currentUser),
          location.pathname
        )}
        replace
      />
    );
  }

  return children;
};

export default PermissionRoute;
